import * as React from 'react';

import styles from '../style/betslip.module.css';

function EmptyBetslip(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      className={styles.emptyBetslip}
      height="204"
      id="emptyBetslip"
      version="1.1"
      viewBox="-2 -2 204 204"
      width="204"
      x="375.7"
      xmlSpace="preserve"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>

      <path
        d="M180.43 192.9c0 3.68-36.19 6.67-80.82 6.67s-80.82-2.99-80.82-6.67c0-3.68 36.19-6.67 80.82-6.67s80.82 2.99 80.82 6.67z"
        fill="#20242e"
        opacity=".2">
      </path>
      <path
        className={styles.dost1}
        d="M138.57 71.68c12.86-1.48 23.75-14.12 24.99-16.22 1.2-2.04 1.77-3.88 1.9-4.85.03-.23-.3-.33-.41-.12-.3.54-.65 1.36-.89 1.93-.8 1.89-1.48 2.42-1.97 2.42-.23-.35.05-1.1 1.2-3.68.53-1.19 1.26-2.83 1.22-3.13-.47-1.28-1.58 1.41-2.02 2.65-.45 1.27-.79 2.66-1.51 2.66-.23 0 .05-1.72.71-3.81 2.4-7.57.17-5.36-.73-1.58-.82 3.44-1.15 5.01-1.47 5.01-.24-.27-.13-1.04.31-3.48.26-1.4.38-3.75.18-4.09-.49-.54-.81.74-.87 1.46-.01.07-.78 7.39-2.11 7.63-1.35.25-1.03-1.82-.83-3.05.21-1.26-.78-2.17-1.15-1.77-.46.5.53 2.05.05 4.07-.48 2.02-1 5.09-1 5.88 0 .02-.03.32-.03.32s-6.57 5.11-16.62 2.3c-10.05-2.81-20.54-30.15-26.75-30.15 0 0-7.09-2.96-15.66 0S75.9 44.35 65.85 41.54C55.8 38.73 49.96 20.88 49.96 20.22c.03-4.12-1.73-6.81-1.71-9.84.01-1.47-.25-1.84-.33-1.92-.11-.1-.47.05-.95.54-.85.87.89 4.52.1 5.33-.17.18-.5.23-.81-.07-1.13-1.1-4.68-11.13-5.54-10.88-.64.19.33 1.86.35 1.91 2.61 5.96 3.4 7.97 2.34 8-.15.01-.3-.06-.44-.2-.89-.87-4.22-9.06-5.64-9.32-.36-.07.54 2.16.55 2.21.41.98 4.23 6.92 3.76 7.8-.88 1.65-5.12-7.55-6.17-6.47-.6.62 1.62 2.83 2.46 4.08 1.72 2.57 2.1 3.21 1.88 3.66-.42.86-2.03-.49-3.18-1.33-.9-.65-2.52-1.83-3.06-1.92.07 1.16 3.38 3.5 4.35 4.21 1.84 1.34 1.5.91 5.96 6.3 1.49 1.79 1.92 3.92 2.24 5.02.06-.03 5.98 18.56 14.44 21.12 9.53 2.88 23.94 1.01 23.94 1.01s-4.72 19.6-7 35c11.54-1.09 22.93-.34 34.22 1.75l4.67-30.96c.01.03 9.32 17.91 22.18 16.43z">
      </path>
      <path
        className={styles.dost2}
        d="M76.32 97.14c0 13.63.66 48.88.66 48.88l3.33 40.79s-3.82 1.19-6.15 2.23c0 0 1.94.21 5.16.21h4.65s.12-1.77.12-4.43 1.11-40.23 1.66-40.79c.55-.55 7.54-38.46 7.54-38.46l11.42 45 7.2 38.68v7.17l3.32 2.36s2.52-3.24 2.52-5.17-2.92-6.08-2.92-6.08l-.92-43.42-3.55-48.62.43-2.85c-10.92-2.77-21.6-7.22-33.35-7.45-.69 4.61-1.12 8.82-1.12 11.95z">
      </path>
      <path
        d="M131.52 58.04c-8.04-8.42-15.77-25.96-20.74-25.96 0 0-7.09-2.96-15.66 0-7.71 2.66-17.09 10.43-26.22 9.93.07 3.54 1.4 6.94 2.56 10.35 6.91-.71 13.05-2.88 13.05-2.88s-5.36 22.23-7.41 37.95c10.9 4.03 21.82 8.46 33.29 8.79l-.05-.74 6.06-40.19s2.64 5.08 7.06 9.59c2.07-2.59 5.05-4.72 8.06-6.84z"
        fill="#052643">
      </path>
      <path
        className={styles.dost1}
        d="M105.91 26.61s-3.47 5.84-3.84 7.54c-.37 1.7 3.1 5.25 6.13 4.36 3.03-.89 9.9-15.37 9.9-15.37l-12.19 3.47z">
      </path>
      <path
        className={styles.dost4}
        d="M116.38 26.6c1.04-2.01 1.72-3.46 1.72-3.46l-12.19 3.47s-.73 1.22-1.55 2.71c.9.75 2.3 1.18 4.27 1.18 2.58 0 5.53-1.99 7.75-3.9z">
      </path>
      <path
        className={styles.dost1}
        d="M114.26 8.58s-2.4-.11-5.39 2.88c-2.99 2.99-5.76 9.6-5.76 13.3 0 2.2 1.67 3.69 5.53 3.69 3.85 0 8.55-4.03 10.36-5.84 1.8-1.8 4.42-11.51-4.74-14.03z">
      </path>
      <path
        className={styles.dost2}
        d="M110.07 13.02s-2.24 1.7-4.31.37c-2.07-1.33-.52-2.96-.52-4.8s-2.44-9.01 5.39-9.01 5.69 9.09 7.98 9.83c2.29.74 7.17.87 6.5 4.5-.67 3.63-2.81 3.04-2.29 5.18.52 2.14-5.43 5.07-6.36 5.77-.93.7-3.17.36-1.1-1.71s3.99-3.18 3.99-4.62-.88-3.51-1.85-2.55c-.44.44-3.03 1.11-3.47-.59-.44-1.7-2.22-.74-3.25-1.03-1.03-.31-.71-1.34-.71-1.34z">
      </path>
      <path
        className={styles.dost1}
        d="M116.54 24.31c.29-.33 1.52-4.07 3.27-2.54 1.75 1.53-.59 4.75-2.37 4.22-1.77-.54-.9-1.68-.9-1.68z">
      </path>
      <path d="M80.63 149.11c.06-1.04.06-1.88.06-1.88s-.05.85-.06 1.88z" fill="#4f80ff"></path>
      <path
        className={styles.dost6}
        d="M39.7 28.83a.36.36 0 01-.11-.02C27.92 25.08 22.54 8.86 22.48 8.7a.37.37 0 01.24-.47c.2-.07.41.04.47.24.05.16 5.32 16.01 16.62 19.63.2.06.31.27.24.47-.05.16-.19.26-.35.26zm3.49 7.18h-.04c-11.53-1.36-15.5-7.1-15.67-7.34-.12-.17-.07-.4.1-.52.17-.11.4-.07.52.1.04.06 3.97 5.7 15.13 7.01.21.02.35.21.33.42a.37.37 0 01-.37.33zm126.63 28c-.1 0-.19-.04-.27-.11a.368.368 0 010-.53c9.49-9.49 5.69-21.12 5.65-21.24a.38.38 0 01.23-.48c.2-.07.41.04.48.23.04.12 4 12.18-5.83 22.01-.07.08-.16.12-.26.12z">
      </path>
      <path
        className={styles.dost4}
        d="M117.62 23.29s1.1-1.38 1.66-.52c.56.87-1.02 2.65-1.99 2.41-.96-.24.33-1.89.33-1.89z">
      </path>
      <path
        className={styles.dost2}
        d="M110.92 18.68c-.19.48-.62.76-.96.62-.34-.13-.45-.63-.25-1.11.19-.48.62-.76.96-.63.33.14.45.64.25 1.12zm-3.54-1.42c-.19.48-.63.76-.96.62-.34-.13-.45-.63-.26-1.11.19-.48.63-.76.96-.62.34.14.45.63.26 1.11zm.16 6.41c-1.11-.26-2.12.15-2.07.14-.26.08-.37-.31-.11-.38.78-.19 1.48-.22 2.24.02 1.1.34 1.93 1.12 1.88 1.17-.01.01-.02.01-.03 0-.21-.13-.77-.7-1.91-.95zm3.99-8.23l-.41.48s1.03.05 1.33 1.07c0 0-.13-1.38-.92-1.55zm-4.65-.44s.83-.18 1.28 0l-.07-.52s-1.01.04-1.21.52zm.18 6.06c.01-.02.14-2.14 2.11-4.74.1-.13.3.02.2.15-.02.02-1.73 2.31-2.04 4.39.71.16 1.03.09 1 .3-.03.21-.3.02-1.27-.1z"
        opacity=".5">
      </path>
    </svg>);

}

export default EmptyBetslip;